import { useEffect, useState } from 'react';

/** One request per pause in typing, not one per keystroke. */
const DEFAULT_DELAY_MS = 300;

/**
 * Hold a fast-changing value still until the typing stops.
 *
 * It lives here rather than beside its first caller because two features now
 * need it — the timeclock's address lookup and the search palette — and a second
 * copy is how the two would quietly grow different delays.
 */
export function useDebounced(value: string, delayMs = DEFAULT_DELAY_MS): string {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return settled;
}
